import React, { useEffect, useMemo } from 'react'

import { Collapsable, AutomaticButtonGroup } from 'components/UI'
import { Select, Input, Checkbox, DateTimePicker } from 'components/Forms'
import { convertToRuleObject } from 'services/schedule/RecurrenceRules'
import { getDaysOfWeek, Format } from 'services/Dates'

import { t } from 'translations'

const RecurrenceRule = ({ rrule, currentDate }) => {
  const currentRule = useMemo(() => convertToRuleObject(rrule), [rrule])

  // This is to avoid keeping an unused value with an error when switching from "Until" to "Count"
  useEffect(() => {
    if (rrule.ends === 'UNTIL') rrule.count = 1
    if (rrule.ends === 'COUNT') rrule.until = Format(currentDate, { outFormat: 'date' })
  }, [currentDate, rrule, rrule.ends])

  return (
    <Collapsable type="recurrenceRule" title="components.recurrenceRule.RECURRENCE_RULE_SECTION" badge={currentRule?.toTextTranslated()}>
      {/* Frequency */}
      <Select
        module="components.recurrenceRule.form"
        translation="frequency"
        name="rrule.frequency"
        options={[
          { name: t('components.recurrenceRule.frequency.NONE'), _id: 'NONE' },
          { name: t('components.recurrenceRule.frequency.DAILY'), _id: 'DAILY' },
          { name: t('components.recurrenceRule.frequency.WEEKLY'), _id: 'WEEKLY' }
        ]}
        dontSort
      />

      {rrule.frequency !== 'NONE' ? (
        <>
          {/* Interval */}
          <Input
            module="components.recurrenceRule.form"
            translation="interval"
            name="rrule.interval"
            min="0"
            step="1"
            type="number"
            inputGroup={
              <div className="input-group-append">
                <span className="input-group-text">{t(`components.recurrenceRule.form.${rrule.frequency}`)}</span>
              </div>
            }
          />

          {/* Day of week */}
          {rrule.frequency === 'WEEKLY' ? (
            <div className="mb-2">
              <AutomaticButtonGroup>
                {getDaysOfWeek(currentDate).map(day => {
                  return (
                    <Checkbox
                      key={day}
                      buttonCheckbox
                      module="components.recurrenceRule.form"
                      translation={day.toLowerCase()}
                      name={`rrule.byWeekDay.${day.toLowerCase()}`}
                    />
                  )
                })}
              </AutomaticButtonGroup>
            </div>
          ) : null}

          {/* Ends */}
          <Select
            module="components.recurrenceRule.form"
            translation="ends"
            name="rrule.ends"
            options={[
              // { name: t('components.recurrenceRule.ends.INDEFINITE'), _id: 'INDEFINITE' },
              { name: t('components.recurrenceRule.ends.UNTIL'), _id: 'UNTIL' },
              { name: t('components.recurrenceRule.ends.COUNT'), _id: 'COUNT' }
            ]}
            dontSort
          />

          {rrule.ends === 'COUNT' ? (
            <Input
              module="components.recurrenceRule.form"
              translation="count"
              min="0"
              step="1"
              name="rrule.count"
              type="number"
              inputGroup={
                <div className="input-group-append">
                  <span className="input-group-text">{t(`components.recurrenceRule.form.COUNT.NUMBER_OCCURENCES`)}</span>
                </div>
              }
            />
          ) : null}

          {rrule.ends === 'UNTIL' ? <DateTimePicker module="components.recurrenceRule.form" translation="until" name="rrule.until" type="date" /> : null}
        </>
      ) : null}
    </Collapsable>
  )
}

export default RecurrenceRule
